export interface IBackupRequestStatusUpdatePayload {
  isBackupRequested: boolean;
  requestType: string;
  message: string;
  deductionInfo: {
    claimNumber: string;
    remittanceItemId: number;
  };
  disputeInfo: {
    disputeId: number;
  };
  requestBackupInfo: {
    id: number;
    note: string;
  };
  brandInfo: {
    brandKey: string;
  };
  purchaserInfo: {
    purchaserKey: string;
  };
  userInfo: {
    userId: number;
  };
}

export enum BackupRequestEvents {
  BACKUP_REQUEST_STATUS_UPDATE = "BACKUP_REQUEST_STATUS_UPDATE",
}

export interface IBackupRequestEventsMap {
  [BackupRequestEvents.BACKUP_REQUEST_STATUS_UPDATE]: BackupRequestStatusUpdatePayload;
}

export class BackupRequestStatusUpdatePayload implements IBackupRequestStatusUpdatePayload {
  private readonly _isBackupRequested: boolean;
  private readonly _requestType: string;
  private readonly _message: string;
  private readonly _deductionInfo: {
    claimNumber: string;
    remittanceItemId: number;
  };

  private readonly _disputeInfo: {
    disputeId: number;
  };
  private readonly _requestBackupInfo: {
    id: number;
    note: string;
  };
  private readonly _brandInfo: {
    brandKey: string;
  };
  private readonly _purchaserInfo: {
    purchaserKey: string;
  };
  private readonly _userInfo: {
    userId: number;
  };

  constructor(data: IBackupRequestStatusUpdatePayload) {
    this._isBackupRequested = data.isBackupRequested;
    this._requestType = data.requestType;
    this._message = data.message;
    this._deductionInfo = data.deductionInfo;
    this._disputeInfo = data.disputeInfo;
    this._requestBackupInfo = data.requestBackupInfo;
    this._brandInfo = data.brandInfo;
    this._purchaserInfo = data.purchaserInfo;
    this._userInfo = data.userInfo;
  }

  public get isBackupRequested(): boolean {
    return this._isBackupRequested;
  }
  public get requestType(): string {
    return this._requestType;
  }
  public get message(): string {
    return this._message;
  }
  public get deductionInfo(): {
    claimNumber: string;
    remittanceItemId: number;
  } {
    return this._deductionInfo;
  }
  public get disputeInfo(): {
    disputeId: number;
  } {
    return this._disputeInfo;
  }
  public get requestBackupInfo(): {
    id: number;
    note: string;
  } {
    return this._requestBackupInfo;
  }
  public get brandInfo(): {
    brandKey: string;
  } {
    return this._brandInfo;
  }
  public get purchaserInfo(): {
    purchaserKey: string;
  } {
    return this._purchaserInfo;
  }
  public get userInfo(): {
    userId: number;
  } {
    return this._userInfo;
  }
  public toJSON(): IBackupRequestStatusUpdatePayload {
    return {
      isBackupRequested: this._isBackupRequested,
      requestType: this._requestType,
      message: this._message,
      deductionInfo: this._deductionInfo,
      disputeInfo: this._disputeInfo,
      requestBackupInfo: this._requestBackupInfo,
      brandInfo: this._brandInfo,
      purchaserInfo: this._purchaserInfo,
      userInfo: this._userInfo,
    };
  }
}
